// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"3c5b31e1","981":"79cd2304"}[chunkId] + ".chunk.js";
};